module.exports = __webpack_public_path__ + "assets/img/shouye_shangpinyuding-xuanzhong.a6db89f1.svg";